export default {
  GET_HISTORY: '@HISTORY_OFFERS/GET_HISTORY',
  GET_HISTORY_SUCCESS: '@HISTORY_OFFERS/GET_HISTORY_SUCCESS',
  GET_HISTORY_FAILURE: '@HISTORY_OFFERS/GET_HISTORY_FAILURE',
  CLEAR_HISTORY_OFFERS: '@HISTORY_OFFERS/CLEAR_HISTORY_OFFERS',

  SET_FILTERS: '@HISTORY_OFFERS/SET_FILTERS',
  SEARCH_BY_MOVEMENT_NUMBER: '@HISTORY_OFFERS/SEARCH_BY_MOVEMENT_NUMBER',
  LOAD_MORE: '@HISTORY_OFFERS/LOAD_MORE'
}
